import { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  Content,
  ProceedButton,
  ButtonContent,
  FieldsContent,
  Wait,
  Loading,
  Red,
} from "./styles";
import { push } from "connected-react-router";
import { CircularProgress } from "@mui/material/";
import InputDetail from "../../components/common/InputDetail";
import SelectDetail from "../../components/common/SelectDetail";
import { useLocation } from "react-router";
import queryString from "query-string";
import FooterContainer from "../../components/common/FooterContainer";
import TitleHeader from "../../components/common/TitleHeader";
import { checkValidMobile } from "../../global/helpers";

const mapStateToProps = ({ dispatch, casinoPlusReducers, globalReducer }) => ({
  dispatch,
  casinoStore: casinoPlusReducers,
  globalStore: globalReducer,
});

const CasinoPlusScreen = ({ dispatch, casinoStore, globalStore }) => {
  const location = useLocation();
  const params = queryString.parse(location.search);
  const [depositDetails, setDepositDetails] = useState({
    mobileNumber: casinoStore.payDetails.mobileNumber,
    amount: casinoStore.payDetails.amount,
  });
  const [error, setError] = useState(false);

  const onProceed = () => {
    if (
      depositDetails.accountType === "Mobile Number" &&
      !checkValidMobile(depositDetails.accountNumber)
    ) {
      setError("Invalid mobile number");
    } else {
      dispatch({
        type: "casino/SET_PAY_DETAILS",
        payload: {
          ...depositDetails,
          amount: depositDetails.amount,
          userId: casinoStore.sessionDetails.userId,
          sessionId: casinoStore.sessionDetails.sessionId,
        },
      });
      dispatch(push("/summary"));
    }
  };

  useEffect(() => {
    dispatch({
      type: "global/CURRENT_ENDPOINT",
      payload: "CASINO PLUS",
    });
    dispatch({
      type: "casino/REQUEST_TOKEN",
      payload: {
        userId: params.userId,
        sessionId: params.sessionId,
      },
    });
  }, [dispatch, params.userId, params.sessionId]);

  useEffect(() => {
    if (casinoStore.sessionDetails.sessionToken) {
      dispatch({
        type: "casino/REQUEST_PRODUCTS",
        payload: {
          token: casinoStore.sessionDetails.sessionToken,
          category: "cignal",
        },
      });
    }
  }, [casinoStore.sessionDetails.sessionToken, dispatch, location]);

  return (
    <>
      <Content>
        <div>
          <TitleHeader
            title={globalStore.pageTitle}
            type={
              globalStore.sessionDetails &&
              globalStore.sessionDetails.sessionType
            }
          />
          <FieldsContent>
            {
              <InputDetail
                title={"Mobile Number"}
                subtitle={"Enter Mobile Number"}
                onChange={(e) => {
                  setDepositDetails({
                    ...depositDetails,
                    mobileNumber: e.target.value,
                  });
                }}
                value={depositDetails.mobileNumber}
                type="number"
              />
            }
            {
              <SelectDetail
                title={"Amount"}
                subtitle={"Choose Amount"}
                options={[50, 100, 200, 500, 1000, 5000, 10000]}
                value={depositDetails.amount}
                onChange={(e) => {
                  setDepositDetails({
                    ...depositDetails,
                    amount: e.target.value,
                  });
                }}
              />
            }

            {casinoStore.loading && (
              <Loading>
                <CircularProgress />
                <Wait>Please wait...</Wait>
              </Loading>
            )}
            {error && <Red> {error}</Red>}
          </FieldsContent>

          <ButtonContent>
            <ProceedButton
              variant="contained"
              onClick={() => {
                onProceed();
              }}
              disabled={!depositDetails.mobileNumber || !depositDetails.amount}
            >
              Deposit
            </ProceedButton>
          </ButtonContent>
        </div>
        <FooterContainer />
      </Content>
    </>
  );
};

export default connect(mapStateToProps)(CasinoPlusScreen);
